module.exports = __webpack_public_path__ + "84b8f42f20e1db19d8814eb34055b86c.png";